module.exports = __webpack_public_path__ + "static/media/a91.38c45950.jpg";